import React  from "react";
import {
  Form,
  Row,
  Col,
  Card,
  Select,
  Upload,
  List,
  message,
  Button,
  Checkbox,
  Input,
  InputNumber,
  Tooltip,
  Icon,
  Spin,
} from "antd";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Prompt } from 'react-router';
import { API } from "aws-amplify";
import { ulid } from "ulid";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import VList from "react-virtualized/dist/commonjs/List";
import sortBy from "lodash/sortBy";
import uniq from "lodash/uniq";
import get from 'lodash/get';
import * as Styled from "./styled";
import { makeBucketName } from "../../utils/bucket";
import { Storage } from "aws-amplify";
import { labActions } from "../../redux/modules/lab";
import { sessionActions } from '../../redux/modules/session';
import FileItem from "./components/file-item";
import MappingItem from './components/mapping-item';
import { tosValidator, validImage } from "../../utils/validators";
import { getTirePrice } from 'utils/price';

const FormItem = Form.Item;

function baseName(str) {
  let base = String(str).substring(str.lastIndexOf("/") + 1);
  if (base.lastIndexOf(".") !== -1)
    base = base.substring(0, base.lastIndexOf("."));
  return base;
}

function baseMappingName(str) {
  return str.replace(/[^aA-zZ]+$/, "").trim();
}

class MappingBulk extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      mappings: []
    };

    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    window.addEventListener("beforeunload", this.handleBeforeunload);
    const mappingPref = get(this.props.preferences, 'mapping');
    if (mappingPref) {
      this.props.form.setFieldsValue(mappingPref);
    }

  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("beforeunload", this.handleBeforeunload);
  }

  handleBeforeunload = event => {
    event.preventDefault();
    let returnValue;
    const pending = this.hasUnsavedChanges();
    if (pending) {
      returnValue =
        "You have unsaved changes. Are you sure you want to leave this page?";
    }
    event.returnValue = returnValue;
    return returnValue;
  };

  hasUnsavedChanges = () => {
    const pending = this.state.mappings.find(m => m.status === 'pending' || m.status === 'uploading');
    return !!pending;
  };

  onCatalogChange = async val => {
    this.props.form.setFieldsValue({
      product_pos_code: undefined
    });
    this.onOptionChange();
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { mappings } = this.state;
        const catalog = this.props.catalogs.find(
          cat => cat.cat_id === values.catalogId
        );
        const products = catalog.products;
        const sosProduct = products.find(
          p => p.pos_code === values.product_pos_code
        );

        const mapping = {
          id: ulid(),
          sku: values.sku,
          quantity: values.quantity,
          name: values.name,
          catalogName: catalog.cat_name,
          catalogId: values.catalogId,
          product_size: sosProduct.size,
          product_pos_code: values.product_pos_code,
          images: values.selectedFiles.map(id =>
            values.images.find(i => i.uid === id)
          ),
          status: "pending" // options：pending, uploading, done, error
        };

        mappings.push(mapping);

        this.setState(
          {
            mappings
          },
          () => {
            this.processQueue();
            this.props.form.setFieldsValue({
              name: "",
              sku: "",
              selectedFiles: []
            });
          }
        );
      }
    });
  };

  processMapping = async mapping => {
    try {
      const uploadPromises = mapping.images.map(file => {
        const { originFileObj, name } = file;
        const bucket = makeBucketName(mapping.id, name);
        return Storage.vault
          .put(bucket, originFileObj, {
            metadata: { type: "bulk" },
            progressCallback: progress => {
              const pc = (progress.loaded / progress.total) * 100;
              file.percent = pc;
              this.forceUpdate();
            }
          })
          .then(result => {
            file.response = result;
          })
          .catch(err => {
            console.error('error uploading');
            console.error(err);
            mapping.error = 'Error uploading file';
            mapping.status = "error";
            throw err;
          });
      });
      await Promise.all(uploadPromises);
      const payload = {
        id: mapping.id,
        name: mapping.name,
        sku: mapping.sku,
        quantity: mapping.quantity,
        catalogName: mapping.catalogName,
        catalogId: mapping.catalogId,
        product_size: mapping.product_size,
        product_pos_code: mapping.product_pos_code,
        images: mapping.images.map(i => i.response.key)
      };
      await API.post("api", "mappings", { body: payload });
      mapping.status = "done";
    } catch (e) {
      console.error('Mapping error');
      console.error(e);
      mapping.status = "error";
      mapping.error = e.response ? get(e, 'response.data.message', e.response.data) : e.message;
    } finally {
      if (this.mounted) {
        this.forceUpdate();
        this.processQueue();
      }
    }
  };

  processQueue = () => {
    const inProgress = this.state.mappings.find(m => m.status === 'uploading');
    if (inProgress) return;
    const next = this.state.mappings.find(m => m.status === 'pending');
    if (next) {
      next.status = 'uploading';
      this.processMapping(next);
    }
  };

  saveSettings = () => {
    const values = this.props.form.getFieldsValue(['autoSelect', 'parseSKU', 'separator', 'suffixCatalog', 'suffixProduct', 'hideUsed']);
    this.props.dispatch(sessionActions.updatePref({ mapping: values }));
  };

  normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  getMappingName = filename => {
    const { getFieldsValue, setFieldsValue } = this.props.form;
    const values = getFieldsValue();
    const {
      suffixCatalog,
      parseSKU,
      separator,
      suffixProduct,
      images,
      selectedFiles,
      catalogId,
      product_pos_code
    } = values;
    if ((selectedFiles && selectedFiles.length) || filename) {
      let name = "";
      if (filename) {
        name = baseMappingName(baseName(filename));
      } else {
        const img = images.find(i => i.uid === selectedFiles[0]);
        name = baseMappingName(baseName(img.originFileObj.name));
      }
      let sku = "";
      if (parseSKU) {
        const parts = name.split(separator);
        if (parts.length > 1) {
          sku = parts[0];
          name = parts.splice(1).join(" ");
        }
      }

      if (suffixCatalog && catalogId) {
        const catalog = this.props.catalogs.find(
          cat => cat.cat_id === catalogId
        );

        name = name + " " + catalog.cat_name;
      }
      if (suffixProduct && product_pos_code) {
        const products = this.props.catalogs.find(c => c.cat_id === catalogId).products;
        const sosProduct = products.find(p => p.pos_code === product_pos_code);
        name = name + " " + sosProduct.size;
      }
      const update = { name };
      if (sku) update.sku = sku;
      setFieldsValue(update);
      return name;
    }
  };

  onOptionChange = e => {
    const { setFieldsValue, getFieldValue } = this.props.form;
    // wait for rerender to update form state
    setTimeout(() => {
      this.saveSettings();
      if (e && e.target && e.target.checked) {
        this.getMappingName();
        const autoSelect = getFieldValue("autoSelect");
        const selectedFiles = getFieldValue("selectedFiles");
        const sku = getFieldValue("sku");
        if (autoSelect && sku) {
          const files = this.getFiles();
          const uids = files
            .filter(f => {
              if (sku) {
                return f.name.startsWith(sku);
              }
              return false;
            })
            .map(f => f.uid);
          setFieldsValue({
            selectedFiles: uniq([...uids, ...selectedFiles])
          });
        }
      }
    }, 0);
  };

  filterFiles = (files = []) => {
    return files.filter(
      f => !this.state.mappings.find(m => m.images.includes(f))
    );
  };

  getFiles = () => {
    const { getFieldValue } = this.props.form;
    let files = getFieldValue("images");
    const hideUsed = getFieldValue("hideUsed");

    if (!files) return [];
    else if (hideUsed) files = this.filterFiles(files);
    return sortBy(files, "name");
  };

  onRemoveMapping = async mapping => {
    if (mapping.status === "done") {
      await API.del("api", `mappings/${mapping.id}`);
    }
    this.setState({
      mappings: this.state.mappings.filter(m => m !== mapping)
    });
  };

  renderFileItem = ({ index, style, key, isScrolling }) => {

    // if (isScrolling) return (
    //   <Skeleton avatar loading paragraph={false} />
    // );
    const files = this.getFiles();
    const file = files[index];
    const existing = this.state.mappings.find(m => m.images.includes(file));
    return (
      <FileItem
        style={{
          ...style,
          backgroundColor: !existing ? "white" : "#ffc"
        }}
        key={file.uid}
        file={file}
        actions={[<Checkbox value={file.uid} onChange={this.onOptionChange} />]}
      />
    );
  };

  renderMappingItem = item => {
    return <MappingItem item={item} onRemoveMapping={this.onRemoveMapping} />;
  };

  renderMappingsList = () => {
    const sorted = sortBy(this.state.mappings, 'status').reverse();
    const isUploading = sorted.find(i => i.status === 'uploading');

    return (
      <List
        header={<span><Spin spinning={!!isUploading} /> Mappings:</span>}
        rowKey="id"
        renderItem={this.renderMappingItem}
        dataSource={sorted}
        locale={{ emptyText: "No mappings defined" }}
      />
    );
  };

  render() {
    const {
      preferences,
      labData,
      catalogs,
      form: { getFieldDecorator, getFieldValue }
    } = this.props;
    getFieldDecorator("keys", { initialValue: [this.id] });

    const fileTypes = labData ? labData.allowed_file_types : 'jpg,jpeg';
    const extensions =
      fileTypes &&
      fileTypes
        .split(",")
        .map(i => `.${i}`)
        .join(",");

    const parseSKU = getFieldValue("parseSKU");
    // const hasPendingUploads = files ? !!files.find(f => !f.response) : true;
    const catalogId = getFieldValue(`catalogId`);
    const selectedFiles = getFieldValue("selectedFiles");
    const files = this.getFiles();
    let products = [];

    if (catalogId) {
      products = catalogs.find(c => c.cat_id === catalogId).products;
    }

    const isUploading = this.state.mappings.find(i => i.status === 'uploading');

    return (
      <Styled.Container>
        <Helmet title={`${!!isUploading ? 'Uploading...' : 'Bulk mapping'}`} />
        <Prompt message="Are you sure you want to leave? You have unsaved changed." when={this.hasUnsavedChanges()}/>
        <h1>Bulk Mapping</h1>
        <p>
          Choose any Mapping options* below that you want and then click Select Files to choose the files you want to create Mappings from.
          <br />*Mapping options are saved so they should be the same the next time you use this.
        </p>
        <Form onSubmit={this.onSubmit} hideRequiredMark>
          <Card style={{ marginBottom: 10 }}>
            <div>Mapping options:</div>
            <Row type="flex" gutter={12}>
              <Col>
                <FormItem>
                  {getFieldDecorator("parseSKU", {
                    initialValue: get(preferences, 'mapping.parseSKU', false),
                    valuePropName: "checked"
                  })(
                    <Checkbox onChange={this.onOptionChange}>
                      <span>
                        Parse SKU from Filename&nbsp;
                        <Tooltip title="If your filenames are prefixed with a SKU and a separator (space, dash, underscore, period or hash) we'll use it to populate the SKU field automatically">
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </span>
                    </Checkbox>
                  )}
                </FormItem>
              </Col>
              {parseSKU && (
                <Col>
                  <FormItem>
                    {getFieldDecorator("separator", {
                      initialValue: get(preferences, 'mapping.separator', ' '),
                    })(
                      <Select onChange={this.onOptionChange}>
                        <Select.Option value=" ">Space</Select.Option>
                        <Select.Option value="-">- (Dash)</Select.Option>
                        <Select.Option value="_">_ (Underscore)</Select.Option>
                        <Select.Option value=".">. (Period)</Select.Option>
                        <Select.Option value="#"># (Hash)</Select.Option>
                      </Select>
                     )}
                  </FormItem>
                </Col>
              )}
              { parseSKU && (
                <Col>
                  <FormItem>
                    {getFieldDecorator("autoSelect", {
                      valuePropName: "checked",
                      initialValue: get(preferences, 'mapping.autoSelect', true),
                    })(
                      <Checkbox onChange={this.onOptionChange}>
                        Auto select files&nbsp;
                        <Tooltip title="Automatically select files with matching SKU">
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </Checkbox>
                    )}
                  </FormItem>
                </Col>
              )}
              <Col>
                <FormItem>
                  {getFieldDecorator("suffixCatalog", {
                    valuePropName: "checked",
                    initialValue: get(preferences, 'mapping.suffixCatalog', false),
                  })(
                    <Checkbox onChange={this.onOptionChange}>
                      <span>
                        Add Catalog Name&nbsp;
                        <Tooltip title="Add catalog name to end of mapping name">
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </span>
                    </Checkbox>
                  )}
                </FormItem>
              </Col>
              <Col>
                <FormItem>
                  {getFieldDecorator("suffixProduct", {
                    valuePropName: "checked",
                    initialValue: get(preferences, 'mapping.suffixProduct', false),
                  })(
                    <Checkbox onChange={this.onOptionChange}>
                      <span>
                        Add Product Name&nbsp;
                        <Tooltip title="Add product name to end of mapping name">
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </span>
                    </Checkbox>
                  )}
                </FormItem>
              </Col>
              <Col>
                <FormItem>
                  {getFieldDecorator("hideUsed", {
                    initialValue: get(preferences, 'mapping.hideUsed', false),
                    valuePropName: "checked"
                  })(
                      <Checkbox onChange={this.onOptionChange}> <span>
                        Hide Used Images&nbsp;
                        <Tooltip title="Hide images after they have been added to a mapping">
                          <Icon type="question-circle-o" />
                        </Tooltip>
                      </span>
                      </Checkbox>
                      )}
                </FormItem>
              </Col>
            </Row>
          </Card>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label="Upload Images - Must be RGB, JPG's only">
                {getFieldDecorator("images", {
                  valuePropName: "fileList",
                  getValueFromEvent: this.normFile,
                  rules: [{ required: true }]
                })(
                  <Upload
                    showUploadList={false}
                    multiple
                    accept={extensions}
                    customRequest={() => false}
                    beforeUpload={validImage}
                  >
                    <Button
                      type="primary"
                      icon="upload"
                      title="RGB JPEG files only"
                      ghost
                    >
                      Select files
                    </Button>
                  </Upload>
                )}
              </FormItem>
              {getFieldDecorator("selectedFiles")(
                <Checkbox.Group>
                  <AutoSizer>
                    {({ width }) => (
                      <VList
                        ref="List"
                        height={500}
                        overscanRowCount={10}
                        noRowsRenderer={() => "Please select files"}
                        rowCount={files.length}
                        rowHeight={50}
                        rowRenderer={this.renderFileItem}
                        width={width}
                      />
                    )}
                  </AutoSizer>
                </Checkbox.Group>
              )}
            </Col>
            <Col span={12}>
              <Card style={{ marginBottom: 10 }}>
                <div>
                  <div>
                    <Row gutter={12}>
                      <Col span={4}>
                        <FormItem label="SKU">
                          {getFieldDecorator(`sku`, {
                            rules: [{ required: false, message: "Optional" }]
                          })(<Input placeholder="SKU #" />)}
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem label="Catalog">
                          {getFieldDecorator(`catalogId`, {
                            rules: [
                              { required: true, message: "Catalog is required" }
                            ]
                          })(
                            <Select
                              onChange={this.onCatalogChange}
                              placeholder="Please select"
                            >
                              {catalogs.map(c => (
                                <Select.Option value={c.cat_id} key={c.cat_id}>
                                  {c.cat_name}
                                </Select.Option>
                              ))}
                            </Select>
                          )}
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem label="Product">
                          {getFieldDecorator(`product_pos_code`, {
                            rules: [
                              { required: true, message: "Product is required" }
                            ]
                          })(
                            <Select
                              placeholder="Please select"
                              onChange={this.onOptionChange}
                            >
                              {products.map(p => (
                                <Select.Option
                                  onChange={this.onOptionChange}
                                  value={p.pos_code}
                                  key={p.pos_code}
                                >
                                  {p.size} (${getTirePrice(p.price)} ea)
                                </Select.Option>
                              ))}
                            </Select>
                          )}
                        </FormItem>
                      </Col>
                      <Col span={4}>
                        <FormItem label="Quantity">
                          {getFieldDecorator(`quantity`, {
                            rules: [{ required: true }],
                            initialValue: 1
                          })(
                            <InputNumber
                              min={1}
                              max={1000}
                              style={{ width: "100%" }}
                            />
                          )}
                        </FormItem>
                      </Col>
                      <Col span={24}>
                        <FormItem label="Name">
                          {getFieldDecorator(`name`, {
                            rules: [{ required: true }]
                          })(<Input type="text" placeholder="Mapping name" />)}
                        </FormItem>
                      </Col>
                    </Row>
                    <FormItem style={{ marginBottom: 20 }}>
                      {getFieldDecorator("tos", {
                        valuePropName: "checked",
                        initialValue: false,
                        rules: [{ validator: tosValidator }]
                      })(
                        <Checkbox className="multiline">
                        I represent and warrant that I possess all necessary rights
                        with respect to these images, and that they do not infringe
                        or otherwise violate any copyright, trade secret right or
                        other intellectual property or other property or proprietary
                        right of any third party. I  agree to indemnify and hold Fromex Photo Lab, Inc and Qprints.com
                         and their directors, officers and employees harmless from and against any and all claims, liabilities, causes of action,
                         damages, losses and expenses (including attorneys’ fees) that may arise from printing these images.
                        </Checkbox>
                      )}
                    </FormItem>
                    <div>
                      <Button
                        disabled={!selectedFiles || !selectedFiles.length}
                        type="primary"
                        htmlType="submit"
                        loading={this.state.saving}
                      >
                        Create Mapping
                      </Button>
                    </div>
                  </div>
                </div>
              </Card>
              <Card>{this.renderMappingsList()}</Card>
            </Col>
          </Row>
        </Form>
      </Styled.Container>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    preferences: state.session.user.preferences,
    ...state.lab
  };
};

export default Form.create()(connect(mapStateToProps)(MappingBulk));
